// methods that return date in the future, for X months from now
export const getMonthInFuture = (monthsInFuture: number): Date => {
  let date = new Date();
  date.setMonth(date.getMonth() + monthsInFuture);
  return date;
};
